import {getPackageHistoryForParentContainer} from "../../../../commons/api/GetPackageHistoryForParentContainerResults"
import {batchGetPackageSummaryForPackageId} from "../../../../commons/api/BatchGetPackageSummaryResults.js";
import {convertWeightToKilograms} from "../safetyReport/Util";

export const getPackageWeightInCartIfAny = async (cartId, nodeId, startTime, endTime) => {
    let packageHistoryResult = await getPackageHistoryForParentContainer(cartId, nodeId, 100, null, startTime, endTime)
    let packageInContainer = packageHistoryResult.packageHistory

    let trackingIds = packageInContainer.map((pp) => pp.trackingId)
    let packageDetails = await batchGetPackageSummaryForPackageId(trackingIds)
    let allPackageWeight = 0;
    for (const packageDetail of packageDetails) {
        allPackageWeight += convertWeightToKilograms(packageDetail.packageWeight.value, packageDetail.packageWeight.unit)
    }
    return allPackageWeight;
}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/GetCartPackageHistory.js